import React, { lazy, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link as ScrollTo } from "react-scroll";
import { Parallax } from "react-scroll-parallax";
import { fadeIn,fadeInLeft } from "../../../Functions/GlobalAnimations";

import { db,storage } from "../../../config/firebase";
import { collection, getDocs, query } from "firebase/firestore";
import { ref, getDownloadURL } from "firebase/storage";
import { getFileURL } from "../../../firebase/storageService";
import HeroIconWithText from "../../../Components/IconWithText/HeroIconWithText";
import CreativeEventsSection from "../../../Components/ModernEventsList/CreativeEventsSection";
import Preloader from "../../../Components/Preloader";
import Team from "../../../Components/Team/Team";
import TextBox from "../../../Components/TextBox/TextBox";
import FooterSection from "../../Footer/FooterSection";
import HeaderSection from "../../Header/HeaderSection";
import ImageGallery from "../../ImageGallery/ImageGallery";
// Icons 
import ambulance from "../../../Assets/img/icons/ambulance.svg";
import contact_info from "../../../Assets/img/icons/contact_info.svg";
import emergency_services from "../../../Assets/img/icons/emergency_services.svg";
import opening from "../../../Assets/img/icons/opening.svg";
import opening_hour from "../../../Assets/img/icons/opening_hour.svg";
import pdf from "../../../Assets/img/icons/pdf.svg";
import { useQueries } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { translateObject } from "../../../services/translationService";

const IconWithText = lazy(() =>
  import("../../../Components/IconWithText/IconWithText")
);

const Buttons = lazy(() => import("../../../Components/Button/Buttons"));
const Overlap = lazy(() => import("../../../Components/Overlap/Overlap"));
const BlogMasonry = lazy(() => import("../../../Components/Blogs/BlogMasonry"));
const MessageBox = lazy(() =>
  import("../../../Components/MessageBox/MessageBox")
);
const StartupPageBannerSlider = lazy(() => import("./StartupBanner"));

const fallbackScheduleBody = [
  {
    img: contact_info,
    title: "Contact Info",
    content: "Email us: info@pambazuka-events.de \n\n Phone: +49 30 555-0123",
  },
  {
    img: opening_hour,
    title: "OFFICE HOURS",
    content:
      "Morning \n Monday to Friday: 09 - 12 AM \n\n Afternoon \n Monday, Wednesday, Friday 2 - 5 PM",
  },
];


const fetchInformationCards = async () => {
  const querySnapshot = await getDocs(collection(db, "informationCard"));
  const fetchedData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

  console.log("Fetched information cards:", fetchedData);

  const defaultIcons = [emergency_services, ambulance, opening];

  if (fetchedData.length > 0) {
    const cardsWithImages = await Promise.all(
      fetchedData.map(async (item, index) => {
        let cardImage = defaultIcons[index] || emergency_services;
        
        // If the item has an imageUrl, try to load it from Firebase Storage
        if (item.imageUrl && item.imageUrl.trim() !== '') {
          try {
            const imageUrl = await getFileURL(item.imageUrl);
            if (imageUrl) {
              cardImage = imageUrl;
              console.log(`Loaded image for card ${index}:`, imageUrl);
            }
          } catch (error) {
            console.error(`Error loading image for card ${index}:`, error);
            // Keep default icon on error
          }
        }

        return {
          id: item.id,
          img: cardImage,
          title: item.Title || `Event ${index + 1}`,
          content: item.Description || "No description available...",
          // Include all event data for proper display
          Title: item.Title,
          Description: item.Description,
          streetAddress: item.streetAddress,
          houseNumber: item.houseNumber,
          postalCode: item.postalCode,
          city: item.city,
          state: item.state,
          country: item.country,
          eventDate: item.eventDate,
          eventTime: item.eventTime,
          contact: item.contact,
          imageUrl: item.imageUrl,
          venue: item.venue,
          schedule: item.schedule
        };
      })
    );
    
    return cardsWithImages;
  }

  // Return default cards if no data found - now with 6 events for better showcase
  return [
    {
      id: "default-1",
      img: emergency_services,
      title: "Sample Event 1",
      content: "Sample event description for the first event...",
      Title: "Sample Event 1",
      Description: "Sample event description for the first event...",
      streetAddress: "Musterstraße",
      houseNumber: "123",
      postalCode: "10115",
      city: "Berlin",
      state: "Berlin",
      country: "Deutschland",
      eventDate: "2024-12-15",
      eventTime: "18:00",
      contact: "contact1@example.com"
    },
    {
      id: "default-2",
      img: ambulance,
      title: "Sample Event 2", 
      content: "Sample event description for the second event...",
      Title: "Sample Event 2",
      Description: "Sample event description for the second event...",
      streetAddress: "Beispielweg",
      houseNumber: "456",
      postalCode: "80331",
      city: "München",
      state: "Bayern",
      country: "Deutschland",
      eventDate: "2024-12-20",
      eventTime: "19:30",
      contact: "contact2@example.com"
    },
    {
      id: "default-3",
      img: opening,
      title: "Sample Event 3",
      content: "Sample event description for the third event...",
      Title: "Sample Event 3",
      Description: "Sample event description for the third event...",
      streetAddress: "Teststraße",
      houseNumber: "789",
      postalCode: "50667",
      city: "Köln",
      state: "Nordrhein-Westfalen",
      country: "Deutschland",
      eventDate: "2024-12-25",
      eventTime: "16:00",
      contact: "contact3@example.com"
    },
    {
      id: "default-4",
      img: emergency_services,
      title: "Sample Event 4",
      content: "Sample event description for the fourth event...",
      Title: "Sample Event 4",
      Description: "Sample event description for the fourth event...",
      streetAddress: "Hauptstraße",
      houseNumber: "101",
      postalCode: "20095",
      city: "Hamburg",
      state: "Hamburg",
      country: "Deutschland",
      eventDate: "2024-12-30",
      eventTime: "20:00",
      contact: "contact4@example.com"
    },
    {
      id: "default-5",
      img: ambulance,
      title: "Sample Event 5",
      content: "Sample event description for the fifth event...",
      Title: "Sample Event 5",
      Description: "Sample event description for the fifth event...",
      streetAddress: "Nebenstraße",
      houseNumber: "42",
      postalCode: "70173",
      city: "Stuttgart",
      state: "Baden-Württemberg",
      country: "Deutschland",
      eventDate: "2025-01-05",
      eventTime: "17:30",
      contact: "contact5@example.com"
    },
    {
      id: "default-6",
      img: opening,
      title: "Sample Event 6",
      content: "Sample event description for the sixth event...",
      Title: "Sample Event 6",
      Description: "Sample event description for the sixth event...",
      streetAddress: "Parkstraße",
      houseNumber: "88",
      postalCode: "01067",
      city: "Dresden",
      state: "Sachsen",
      country: "Deutschland",
      eventDate: "2025-01-10",
      eventTime: "15:00",
      contact: "contact6@example.com"
    },
  ];
};



const fetchTeamData = async () => {
  const headerSnapshot = await getDocs(collection(db, "teamHeader"));
  const bodySnapshot = await getDocs(collection(db, "teamBody"));
  const header = headerSnapshot.docs.length > 0 ? headerSnapshot.docs[0].data().title : "Our Event Team";
  
  console.log("Team body data:", bodySnapshot.docs.map(doc => doc.data()));
  
  const body = await Promise.all(bodySnapshot.docs.map(async doc => {
    const data = doc.data();
    const imagePath = data.image || data.imageUrl || data.img;
    const imageUrl = await getImageUrl(imagePath);
    
    console.log("Team member image path:", imagePath);
    console.log("Team member image URL:", imageUrl);
    
    return { 
      img: imageUrl || '/path/to/default/image.jpg',
      name: data.name,
      designation: data.designation 
    };
  }));
  return { header, body };
};


const fetchBlogData = async () => {
  const querySnapshot = await getDocs(collection(db, "blogs"));
  
  console.log("Blog data:", querySnapshot.docs.map(doc => doc.data()));
  
  const data = await Promise.all(querySnapshot.docs.map(async doc => {
    const blogData = doc.data();
    const imagePath = blogData.image || blogData.imageUrl || blogData.img;
    const imageUrl = await getImageUrl(imagePath);
    
    console.log("Blog image path:", imagePath);
    console.log("Blog image URL:", imageUrl);
    
    return {
      id: doc.id,
      title: blogData.title,
      date: blogData.publicationDate ? new Date(blogData.publicationDate).toLocaleDateString() : "",
      content: blogData.content,
      img: imageUrl || '/path/to/default/image.jpg',
      category: blogData.tags || [],
      publicationDate: blogData.publicationDate ? new Date(blogData.publicationDate) : new Date(),
    };
  }));
  
  return data.sort((a, b) => b.publicationDate - a.publicationDate).slice(0, 3);
};

const fetchFormData = async () => {
  const headerSnapshot = await getDocs(collection(db, "formHeader"));
  const bodySnapshot = await getDocs(collection(db, "formBody"));
  const header = headerSnapshot.docs.length > 0 ? headerSnapshot.docs[0].data().title : "Event Registration Forms";
  const body = await Promise.all(bodySnapshot.docs.map(async doc => {
    const fileUrl = await getImageUrl(doc.data().file);
    return {
      img: pdf,
      title: doc.data().title,
      content: `<a href="${fileUrl}" target="_blank" download>Preview</a>`,
    };
  }));
  return { header, body };
};

const fetchScheduleData = async () => {
  const headerSnapshot = await getDocs(collection(db, "scheduleHeader"));
  const bodySnapshot = await getDocs(collection(db, "scheduleBody"));
  const header = headerSnapshot.docs.length > 0 ? headerSnapshot.docs[0].data().title : "Office Hours";
  const body = bodySnapshot.docs.map((doc, index) => ({
    img: fallbackScheduleBody[index]?.img,
    title: doc.data().title,
    content: doc.data().description,
  }));
  return { header, body };
};

const fetchEventsHeader = async () => {
  const headerSnapshot = await getDocs(collection(db, "eventsHeader"));
  if (headerSnapshot.docs.length > 0) {
    const data = headerSnapshot.docs[0].data();
    return {
      title: data.title || "Current Events",
      subtitle: data.subtitle || "Discover our upcoming events and available services"
    };
  }
  return {
    title: "Current Events",
    subtitle: "Discover our upcoming events and available services"
  };
};

const getImageUrl = async (imagePath) => {
  try {
    const imageRef = ref(storage, imagePath);
    const url = await getDownloadURL(imageRef);
    return url;
  } catch (error) {
    console.error("Error fetching image URL:", error);
    return null;
  }
};
const fetchGalleryData = async () => {
  const headerSnapshot = await getDocs(collection(db, "galleryHeader"));
  const bodySnapshot = await getDocs(collection(db, "galleryBody"));
  const header = headerSnapshot.docs.length > 0 ? headerSnapshot.docs[0].data().title : "Event Gallery";
  const body = await Promise.all(bodySnapshot.docs.map(async doc => {
    const img = await getImageUrl(doc.data().image);
    return { src: img, category: doc.data().category, title: doc.data().title };
  }));
  return { header, body };
};

const HomeStartupPage = (props) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const [blogs, setBlogs] = useState([]);
  const [isLoadingBlogs, setIsLoadingBlogs] = useState(true);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const blogData = await fetchBlogData();
        if (lang !== 'de') {
          const translated = await Promise.all(
            blogData.map(b => translateObject(b, ['title', 'content'], lang))
          );
          setBlogs(translated);
        } else {
          setBlogs(blogData);
        }
      } catch (error) {
        console.error("Error fetching blog data:", error);
      } finally {
        setIsLoadingBlogs(false);
      }
    };

    fetchBlogs();
  }, [lang]);

  const translateResults = async (fetchFn, fields) => {
    const data = await fetchFn();
    if (lang === 'de' || !data) return data;
    if (Array.isArray(data)) {
      return Promise.all(data.map(item => translateObject(item, fields, lang)));
    }
    if (data.header && data.body) {
      const translatedBody = await Promise.all(
        data.body.map(item => translateObject(item, fields, lang))
      );
      return { ...data, header: (await translateObject({ header: data.header }, ['header'], lang)).header, body: translatedBody };
    }
    return translateObject(data, fields, lang);
  };

  const results = useQueries({
    queries: [
      { queryKey: ["informationCards", lang], queryFn: () => translateResults(fetchInformationCards, ['title', 'content', 'Title', 'Description']) },
      { queryKey: ["teamData", lang], queryFn: () => translateResults(fetchTeamData, ['name', 'designation']) },
      { queryKey: ["formData", lang], queryFn: () => translateResults(fetchFormData, ['title']) },
      { queryKey: ["scheduleData", lang], queryFn: () => translateResults(fetchScheduleData, ['title', 'content']) },
      { queryKey: ["galleryData", lang], queryFn: () => translateResults(fetchGalleryData, ['title']) },
      { queryKey: ["eventsHeader", lang], queryFn: () => translateResults(fetchEventsHeader, ['title', 'subtitle']) },
    ],
  });

  const isLoading = results.some((result) => result.isLoading) || isLoadingBlogs;

  if (isLoading) {
    return <Preloader />;
  }

  const [
    { data: informationCards },
    { data: teamData },
    { data: formData },
    { data: scheduleData },
    { data: galleryData },
    { data: eventsHeader },
  ] = results;

  return (
    <div style={{ ...props.style, fontFamily: "'Poppins', sans-serif" }}>

      <HeaderSection {...props} />

      <StartupPageBannerSlider />

      {/* Events Section */}
      <section style={{ background: '#FFFBF5' }}>
        <CreativeEventsSection
          events={informationCards}
          header={eventsHeader}
        />
      </section>

      {/* Gallery Section */}
      <section style={{ background: '#ffffff', padding: '96px 0' }}>
        <Container>
          <Row>
            <Col className="text-center" style={{ marginBottom: '48px' }}>
              <span style={{
                display: 'inline-block',
                fontSize: '13px',
                fontWeight: 600,
                color: '#D4A853',
                textTransform: 'uppercase',
                letterSpacing: '2px',
                marginBottom: '12px'
              }}>
                {t('home.gallery')}
              </span>
              <h2 style={{
                fontSize: '2rem',
                fontWeight: 700,
                color: '#1a1a2e',
                fontFamily: "'Poppins', sans-serif"
              }}>
                {galleryData.header}
              </h2>
            </Col>
          </Row>
          <Row>
            <ImageGallery
              theme="image-gallery-02"
              grid="grid grid-4col xl-grid-4col lg-grid-3col md-grid-2col sm-grid-2col xs-grid-1col gutter-large"
              data={galleryData.body}
              overlay={["#D4A853", "#7BAE7F", "#1a1a2e", "#D4A853", "#7BAE7F"]}
              animation={fadeIn}
            />
          </Row>
        </Container>
      </section>

      {/* Team Section */}
      <section style={{ background: '#f8f9fa', padding: '96px 0' }}>
        <Container>
          <Row>
            <Col md={12} className="text-center" style={{ marginBottom: '48px' }}>
              <span style={{
                display: 'inline-block',
                fontSize: '13px',
                fontWeight: 600,
                color: '#D4A853',
                textTransform: 'uppercase',
                letterSpacing: '2px',
                marginBottom: '12px'
              }}>
                {t('home.ourPeople')}
              </span>
              <h2 style={{
                fontSize: '2rem',
                fontWeight: 700,
                color: '#1a1a2e',
                fontFamily: "'Poppins', sans-serif"
              }}>
                {teamData.header}
              </h2>
            </Col>
          </Row>
          <Team
            themeColor="dark"
            theme="team-style-04"
            color={["#1a1a2e", "#D4A853", "#7BAE7F", "#1a1a2e", "#D4A853"]}
            data={teamData.body}
            animation={fadeIn}
            carousel={true}
            carouselOption={{
              slidesPerView: 1,
              spaceBetween: 24,
              loop: true,
              navigation: false,
              autoplay: { delay: 4000, disableOnInteraction: false },
              pagination: { dynamicBullets: true, clickable: true },
              breakpoints: {
                1200: { slidesPerView: 4 },
                992: { slidesPerView: 3 },
                768: { slidesPerView: 2 },
              },
            }}
          />
        </Container>
        <Container>
          <Row className="justify-center" style={{ marginTop: '40px' }}>
            <Col className="text-center">
              <Buttons
                ariaLabel="button"
                href="/teamdetail"
                className="btn-fill mx-[10px] font-medium uppercase"
                size="lg"
                color="#ffffff"
                themeColor="#1a1a2e"
                title={t('home.viewAllTeam')}
                style={{ borderRadius: '12px', fontFamily: "'Poppins', sans-serif" }}
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Forms Section */}
      <section style={{ background: '#ffffff', padding: '96px 0' }}>
        <Container>
          <Row>
            <Col className="text-center" style={{ marginBottom: '48px' }}>
              <span style={{
                display: 'inline-block',
                fontSize: '13px',
                fontWeight: 600,
                color: '#D4A853',
                textTransform: 'uppercase',
                letterSpacing: '2px',
                marginBottom: '12px'
              }}>
                {t('home.resources')}
              </span>
              <h2 style={{
                fontSize: '2rem',
                fontWeight: 700,
                color: '#1a1a2e',
                fontFamily: "'Poppins', sans-serif"
              }}>
                {formData.header}
              </h2>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col xs={12} md={12}>
              <IconWithText
                grid="row-cols-1 row-cols-lg-4 row-cols-md-2 justify-center gap-y-10"
                theme="icon-with-text-08"
                data={formData.body}
                animation={fadeIn}
                animationDelay={0.2}
                highlightAllCard={true}
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Blog / Programme Section */}
      <section style={{ background: '#FFFBF5', padding: '96px 0' }}>
        <Container>
          <Row className="justify-center">
            <Col lg={6} className="text-center" style={{ marginBottom: '48px' }}>
              <span style={{
                display: 'inline-block',
                fontSize: '13px',
                fontWeight: 600,
                color: '#D4A853',
                textTransform: 'uppercase',
                letterSpacing: '2px',
                marginBottom: '12px'
              }}>
                {t('home.newsUpdates')}
              </span>
              <h2 style={{
                fontSize: '2rem',
                fontWeight: 700,
                color: '#1a1a2e',
                fontFamily: "'Poppins', sans-serif"
              }}>
                {t('home.programme')}
              </h2>
            </Col>
          </Row>
        </Container>
        <Container fluid="xs" className="mx-auto">
          <BlogMasonry
            pagination={false}
            filter={false}
            grid="grid grid-3col xl-grid-3col lg-grid-3col md-grid-2col sm-grid-2col xs-grid-1col gutter-double-extra-large"
            data={blogs}
          />
          <Col className="text-center" style={{ marginTop: '40px' }}>
            <Buttons
              ariaLabel="button"
              href="/allnews"
              className="btn-fill mx-[10px] font-medium uppercase"
              size="lg"
              color="#ffffff"
              themeColor="#1a1a2e"
              title={t('home.viewAllProgramme')}
              style={{ borderRadius: '12px', fontFamily: "'Poppins', sans-serif" }}
            />
          </Col>
        </Container>
      </section>

      <FooterSection />
    </div>
  );
};

export default HomeStartupPage;
